import type { FeedbackMessages } from './en';

const cs: FeedbackMessages = {
  qualified: {
    title: 'Děkujeme, že jste dokončili tento průzkum!',
    text: 'Nyní můžete zavřít okno prohlížeče.\n\nDoufáme, že se s Vámi brzy setkáme znovu.',
  },
  quotaFull: {
    title: 'Tento průzkum je uzavřen',
    text: 'Děkujeme za Váš zájem o náš průzkum.\n\nBohužel jsme již obdrželi všechny odpovědi, které jsme potřebovali.\n\nDoufáme, že se s Vámi setkáme v některém z našich budoucích průzkumů!',
  },
  terminated: {
    title: 'Děkujeme za Vaši zpětnou vazbu!',
    text: 'Doufáme, že se s Vámi brzy setkáme v některém z našich budoucích průzkumů. Do té doby Vám přejeme krásný den.\n\nZavřete prosím toto okno prohlížeče.',
  },
  mismatch: {
    title: 'Děkujeme za Váš zájem',
    text: 'Bohužel nespadáte do cílové skupiny pro tento konkrétní průzkum.\n\nTuto stránku můžete zavřít.',
  },
  error: {
    title: 'Vaši žádost nelze zpracovat',
    linkProblemDetailed:
      'S odkazem, na který jste klikli, se vyskytl problém. Zkontrolujte prosím, zda odkaz v adresním řádku odpovídá tomu, který Vám byl zaslán, a zkuste to znovu.',
    linkProblemGeneric:
      'S odkazem, na který jste klikli, se vyskytl problém. Zkuste to prosím znovu.',
    contactPerson:
      'Pokud problém přetrvává, informujte o něm prosím osobu, od které jste odkaz obdrželi.',
  },
};

export default cs;
